<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="120px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名" prop="name">
              <el-autocomplete
                :disabled="disabled"
                v-model="formParameter.name"
                :fetch-suggestions="querySearch1"
                placeholder="请输入"
                :trigger-on-focus="false"
                @select="handleSelect1"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="sex">
              <el-radio v-model="formParameter.sex" label="女">女</el-radio>
              <el-radio v-model="formParameter.sex" label="男">男</el-radio></el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="" prop="grade">
              <el-radio v-model="formParameter.grade" label="高中"
                >高中</el-radio
              >
              <el-radio v-model="formParameter.grade" label="大专"
                >大专</el-radio
              >
              <el-radio v-model="formParameter.grade" label="低学历"
                >低学历</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="手机" prop="mobile">
              <el-input
                :disabled="disabled"
                @blur="queryMobile()"
                v-model="formParameter.mobile"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出生年月" prop="age">
              <el-date-picker
                v-model="formParameter.age"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择年月"
                default-value="2000-03-01"
              >
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="毕业学校" prop="schoolid">
              <el-autocomplete
                :disabled="disabled"
                v-model="formParameter.schoolid"
                :fetch-suggestions="querySearch3"
                placeholder="请输入"
                :trigger-on-focus="false"
                @select="handleSelect3"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="毕业时间" prop="gradedate">
              <el-date-picker
                v-model="formParameter.gradedate"
                value-format="yyyy"
                type="year"
                placeholder="选择年"
              >
              </el-date-picker
            ></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="专业" prop="subject"
              ><el-input
                v-model="formParameter.subject"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="类型" prop="type"
              ><el-select
                v-model="formParameter.type"
                @change="selectRecruid"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typelist"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="意向报读" prop="post"
              ><el-select v-model="formParameter.post" placeholder="请选择">
                <el-option
                  v-for="item in postlist"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所在城市" prop="city">
              <el-input
                v-model="formParameter.city"
                autocomplete="off"
              ></el-input
            > </el-form-item>
          </el-col>
         
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark"
              ><el-input
                type="textarea"
                :rows="3"
                v-model="formParameter.remark"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row v-has-permission-code-and="'003000550025'">
          <el-col :span="24">
            <el-form-item label="内部备注" prop="remark2"
              ><el-input
                type="textarea"
                :rows="15"
                v-model="formParameter.remark2"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultationxl/consultationxl.js";
import apisch from "@/api/consu/colleges/colleges.js";

export default {
  name: "edit",
  components: {
    popup
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: { rank: 0 },

      //备选名称
      schools: [],
      names: [],
      mobiles: [],

      postlist: [ '大专', '本科', '中专','其他'],
      typelist: [],
      isptshow: true,

      sclist: [],
      jslist: [],
      qdaolist: [],
      me: {},

      borderhover: false, //文件拖拖动到区域的hover效果
      fileData: false,

      rules: {
        //手机
        mobile: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            min: 11,
            max: 11,
            trigger: "blur",
          },
        ],
        //用户id
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        email: [
          {
            validator: this.$validate.email,
            trigger: "blur",
          },
        ],
        //岗位
        post: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        type: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    uploadChange(){
     //  console.log(this.formParameter.resumeA)
    },
     selectRecruid() {
      if (this.formParameter.type == "推广") {
        this.isptshow = true;
      }
    },
    querySearch1(queryString, cb) {
      if (queryString && queryString.length >= 2) {
        api.nameIn({ name: queryString }, (res) => {
          if (res.data) {
            this.names = res.data;
            let names = this.names;
            let results = queryString
              ? names.filter(this.createStateFilter1(queryString))
              : names;
            // 按el-autocomplete要求封装数据
            if (results && results.length > 0) {
              let rslt = [];
              results.forEach((v) => {
                rslt.push({
                  value: v + " - 已存在",
                });
              });
              cb(rslt);
            } else {
              cb([]);
            }
          }
        });
      }
    },
    createStateFilter1(queryString) {
      return (state) => {
        return state.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect1(item) {
      // do nothing
    }, queryMobile() {
      if (this.formParameter.mobile && this.formParameter.mobile.length >= 11) {
        api.mobileIn({ mobile: this.formParameter.mobile }, (res) => {
          if (res.data && res.data.length > 0) {
            this.$alert(
              "请在搜索框精确输入[" +
                this.formParameter.name +
                "]+[" +
                this.formParameter.mobile +
                "]查询当前跟进人，友好协商解决。",
              "数据冲突!",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.formParameter.name = "";
                  this.formParameter.mobile = "";
                },
              }
            );
          }
        }); 
      }
    },
    queryEmail() {
      if (this.formParameter.email && this.formParameter.email.length >= 7) {
        api.emailIn({ email: this.formParameter.email }, (res) => {
          if (res.data && res.data.length > 0) {
            this.$alert(
              "邮箱地址[" +
                this.formParameter.email +
                "]已存在。",
              "数据冲突!",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.formParameter.email = "";
                },
              }
            );
          }
        });
      }
    },
    querySearch3(queryString, cb) {
      apisch.nameIn({ name: queryString }, (res) => {
        if (res.data) {
          this.schools = res.data;
          let schools = this.schools;
          let results = queryString
            ? schools.filter(this.createStateFilter3(queryString))
            : schools;
          // 按el-autocomplete要求封装数据
          if (results && results.length > 0) {
            let rslt = [];
            results.forEach((v) => {
              rslt.push({
                value: v,
              });
            });
            cb(rslt);
          } else {
            cb([]);
          }
        }
      });
    },
    createStateFilter3(queryString) {
      return (state) => {
        return state.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect3(item) {
      // do nothing
    },  
    //打开弹框
    open(parameter, title, disabled, size) {

         this.typelist = [
            "推广",
            "转介绍",
            "自招",
          ];
        this.parameter = parameter;

      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;

      this.$caches.consu.set({
        type: this.formParameter.type,
        post: this.formParameter.post,
        recruid: this.formParameter.recruid,
      });
      this.formParameter={}
      this.parameter = {};

      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$emit("flush");
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容

      let consu = this.$caches.consu.get();
      if (consu) {
        this.formParameter = {
          state: "录入待通知",
          grade: "本科",
          sex: "男",
          type: consu.type,
          post: consu.post,
          recruid: consu.recruid,
        };
      } else {
        this.formParameter = {
          state: "录入待通知",
          grade: "本科",
          sex: "男",
          rank: 0,
        };
      }
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (res) => {
          this.formParameter = res.data.record;
          this.sclist = res.data.zx;
          this.jslist = res.data.js;
          this.qdaolist = res.data.qd;

          this.popupLoading = false;
        });
      } else {
        //添加
        this.popupLoading = false;
      }
     
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
